export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11043.c14db8d8.jpg";